import { createContext, useCallback, useReducer } from "react";
import TransactionReducer from "./TransactionReducer";
import { getTransactions } from "./apiCalls"; // change to your actual path

const INITIAL_STATE = {
    transactions: [],
    isFetching: false,
    error: false,
    hasFetched: false,
};

export const TransactionContext = createContext(INITIAL_STATE);

export const TransactionContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(
        TransactionReducer,
        INITIAL_STATE
    );

    const fetchTransactions = useCallback(
        async (toast, forceRefresh = false) => {
            // Don't call API again if data has already been loaded
            if (state.hasFetched && !forceRefresh) {
                return;
            }

            await getTransactions(dispatch, toast);
        },
        [state.hasFetched]
    );

    return (
        <TransactionContext.Provider
            value={{
                transactions: state.transactions,
                isFetching: state.isFetching,
                error: state.error,
                hasFetched: state.hasFetched,
                dispatch,
                fetchTransactions,
            }}
        >
            {children}
        </TransactionContext.Provider>
    );
};